import { render, staticRenderFns } from "./CandidateView.vue?vue&type=template&id=227a2920"
import script from "./CandidateView.vue?vue&type=script&lang=js"
export * from "./CandidateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports